import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7ppxujm6z: FaireProductEntity = {
  token: "p_t7ppxujm6z",
  type: "product",
  name: "Comfort Colors Custom Tshirt, Customizable Products",
  brandToken: "b_6zj4dcu23e",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2436af33a2a804f0e483a559cfd67cd4a06ed739077364e319727dbe1ce21d38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bc7e7ca8758dc292e234c273780479d87c1e90657db7d641c2d9b0e722a5317.jpeg",
    "https://cdn.faire.com/fastly/5a819e62f61cb0d8e8cc7073098701dacafeb1b4e0568d318db974228a0b435f.png",
    "https://cdn.faire.com/fastly/c5183a46ac68511df7540e5975bfdb9c3303eda6a27bee70955aba9ab44a3a7d.png",
    "https://cdn.faire.com/fastly/ff0e8f63df85d81504f836db9d4f1b69d8898c2521cd823c047fd60b2deebcbc.png",
  ],
  priceDollars: 26.33,
  description:
    "Our Comfort Colors Custom Shirt is perfect for your customizing needs! \nWe can custom anything from states/cities, brand names, bridal/bridesmaids, family sweatshirts, school mascot\n\n- Comfort Colors Garment-Dyed Heavyweight T-Shirt\n- Soft ring spun cotton fabric with 100%, cotton threads \n- All our tshirts run a UNISEX fit\n- These letters are iron-on patch and is heat pressed, not embroidered. Rest assured, they won't fall off. :)\n\nIMPORTANT! Please be mindful that we do not accept returns, exchange or order cancellations because all of our items are made to order. \n\nHandmade with love in Chicago. Support small businesses. Shop small. ♡\n\nTags: \nCustomizable Products, Customizable Shirt, Custom Comfort Colors Shirt, Custom Tee, Custom Shirt, Custom Tshirt, Personalized Tshirt, Personalized Tee, Personalizable Products, Vintage Shirts, Custom College Tee, Custom Text Shirt, Custom College Shirt, School Mascot Shirt, Comfort Colors Tshirts, Comfort Colors Tee",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:32.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
